"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CitationPageElementsPageSchema = exports.CitationPageElementSchema = exports.CitationTableRowSchema = void 0;
const z = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
exports.CitationTableRowSchema = z.object({
    rowIndex: z.number().int().nonnegative(),
    text: z.string().nullable(),
    boundingBox: sigma_engine_shared_1.boundingBoxSchema,
});
exports.CitationPageElementSchema = z.object({
    elementIndex: z.number().int().nonnegative(),
    elementType: sigma_engine_shared_1.PdfElementTypeSchema,
    text: z.string().nullable(),
    boundingBox: sigma_engine_shared_1.boundingBoxSchema,
    tableRows: exports.CitationTableRowSchema.array().optional(),
});
exports.CitationPageElementsPageSchema = z.object({
    pageNumber: z.number().int().positive(),
    elements: exports.CitationPageElementSchema.array(),
});
//# sourceMappingURL=citation-page-elements.types.js.map